import * as api_urls from './../config/api_urls';
import * as UserActions from './../actions/user_actions';
import * as ReportActions from './../actions/report_actions';

import * as SettingScreen from './../actions/settingScreen_actions';
import * as TicketActions from './../actions/ticket_actions';

import * as DashboardActions from './../actions/dashboard_actions';
import * as QuestionnaireActions from './../actions/questionnaire_actions';
import * as FacilitiesActions from './../actions/facilities_actions';

import * as PatientsActions from './../actions/admin/patients_actions';
import * as AdminDashboardActions from './../actions/admin/dashboard_actions';
import * as AdminSettingAactions from './../actions/admin/adminSetting_action';

import * as ReasonActions from './../actions/reason_actions';



export var failed_manager =
    (dispatch, endpoint, payload, response, error, requestedEndpoint) => {        

        if (response === null) {
            serverNotFound(dispatch, response);
            return;
        }
        if (response && response.message === 'User is offline.') {
            alert('Please check your internet connection and try again.');
        } else if (!response && endpoint !== api_urls.AUTH_KEY) {
            if (response !== false) {
                // alert('Unexpected error occurred. Please try again.');
            }
        }

        if (response && response.data && response.data.msg && response.data.msg === 'Authentication Timeout') {
            response.data.msg = 'Creating your new session.';
        }

        switch (requestedEndpoint) {

          case api_urls.MULTI_FACILITY_REQUEST: {
              multi_facility_request(dispatch, response);
          };
              break;
            case api_urls.EXPORT_DATA: {
                exportData(dispatch, response);
            }; break;
            case api_urls.VERIFY_OTP: {
                otpFailure(dispatch, response);

            }; break;
            case api_urls.LOGIN: {
                loginFailedDetails(dispatch, response);
            };
                break;
            case api_urls.FORGOT_USER_NAME: {

                userNameFailed(dispatch, response);
            };
                break;
            case api_urls.FORGOT_PASSWORD: {

                forgotPwdFailed(dispatch, response);
            };
                break;

            case api_urls.CHANGE_PASSWORD:
                {
                    changepasswordFaild(dispatch, response);
                };
                break;
            case api_urls.REGISTRATION_PROFILE_UPDATE:
                {
                    Profile_Update(dispatch, response);
                };
                break;
            case api_urls.PROFILE_UPDATE:
                {
                    Profile_Update(dispatch, response);
                };
                break;
            case api_urls.PASS_VERIFICATION:
                {
                    verifypasswordFaild(dispatch, response);
                };
                break;
            case api_urls.DASHBOARD_DETAILS_FAIL: { //api_urls.get(api_urls.FORGOT_USER_NAME)

                dashboardfail(dispatch, response);
            };
                break;
            case api_urls.NOTIFICATIONS_DETAILS_FAIL: {

                notificationFail(dispatch, response);
            };
                break;
            case api_urls.QUESTIONNAIRE_DETAILS_FAIL: {

                questionnaireFail(dispatch, response);
            };
                break;
            case api_urls.CREATE_FACILITY:
                {
                    createFaclity(dispatch, response);
                };
                break;
            case api_urls.UPDATE_FACILITY:
                {
                    updateFaclity(dispatch, response);
                };
                break;
            // need to remove, will be deprecated. now using "GET_FACILITIES_BY_SEARCH" api instead of this.
            case api_urls.GET_ALL_FACILITY:
                {
                    getgetFaclity(dispatch, response);
                };
                break;

            case api_urls.ANSERTYPE_DETAILS_FAIL:
                {
                    answerFaild(dispatch, response);
                };
                break;
            case api_urls.CREATE_UNIQUE_FAIL:
                {
                    createUniqueFaild(dispatch, response);
                };
                break;

            case api_urls.GET_FACILITY_BY_ID:
                {
                    getFaclitybyId(dispatch, response);
                };
                break;

            case api_urls.GET_FACILITIES_BY_SEARCH:
                {
                    getfacilitiesbySearch(dispatch, response);
                };
                break;
            case api_urls.ADD_FACILITY_ADMIN:
                {
                    addFaclitybyAdmin(dispatch, response);
                };
                break;
            case api_urls.GET_ADMIN_USER_BY_ID:
                {
                    getFacilityAdmin(dispatch, response);
                };
                break;
            case api_urls.QUESTIONS_UPDATE:
                {
                    quetionUpDate(dispatch, response);
                };
                break;
            case api_urls.ACTIVATE_FACILITY_ADMIN:
                {
                    activatefacilityadmin(dispatch, response);
                };
                break;
            case api_urls.DEACTIVATE_FACILITY_ADMIN:
                {
                    deactivatefacilityadmin(dispatch, response);
                };
                break;
            case api_urls.PASS_VERIFICATION:
                {
                    verficationFaild(dispatch, response);
                };
                break;
            case api_urls.VERIFY_SECURITY: {
                securityQuestionFaild(dispatch, response);
            }
                break;
            // Wrote the new case:  case api_urls.UPDATE_SECURITY_QUESTIONS:
            // case api_urls.UPDATE_QUESTIONS: {
            //     updateSQFaild(dispatch, response);
            // }
            // break;
            case api_urls.FACILITY_IMAGE_UPLOAD: {
                uploadFacilityImage(dispatch, response);
            }
                break;
            case api_urls.DEACTIVATE_FACILITY:
                {
                    deactivatefacility(dispatch, response);
                };
                break;

            // Registration
            case api_urls.GET_HEIGHEST_DEGREES:
                {
                    getHighestDegrees(dispatch, response);
                };
                break;
            case api_urls.GET_PROFESSIONAL_ROLES:
                {
                    getProfessionalRoles(dispatch, response);
                };
                break;
            case api_urls.GET_ETHNICITIES:
                {
                    getEthnicities(dispatch, response);
                };
                break;
            //Admin Users
            // deprecated need to remove
            case api_urls.GET_ALL_PATIENTS_DATA:
                {
                    get_patients_data(dispatch, response);
                };

                break;
            // deprecated need to remove
            case api_urls.GET_ALL_STAFF_DATA:
                {
                    get_staff_data(dispatch, response);
                };

                break;
            // GET_USERS_BY_ROLE - Replacement of GET_ALL_STAFF_DATA and GET_ALL_PATIENTS_DATA
            case api_urls.GET_USERS_BY_ROLE:
                {
                    set_Users_By_Role(dispatch, response);
                };
                break;
            case api_urls.ADMIN_DASHBOARD:
                {
                    adminDashboard(dispatch, response);
                };
                break;

            case api_urls.GET_SURVEY_LIST:
                {
                    getSurveList(dispatch, response);
                };

                break;
            case api_urls.GET_PATIENT_INFO:
                {
                    getPatientinfo(dispatch, response);
                };

                break;
            case api_urls.REDFLAG:
                {
                    getRedFlagInfo(dispatch, response);
                };

                break;

            case api_urls.ADMIN_SELECT:
                {
                    adminSelectFail(dispatch, response);
                };
                break;
            case api_urls.ADMIN_REQUEST_TO_DEACTIVATE:
                {
                    adminDeactivateFail(dispatch, response);
                };
                break;

            // Response of get all security questions API
            case api_urls.GET_ALL_SECURITY_QUESTIONS:
                {
                    setAllSecrityQuestionsResponse(dispatch, response);
                };
                break;
            case api_urls.GET_ALL_RANDOM_SECURITY_QUESTIONS:
                {
                    setAllRandomSecurityQuestionsByIdResponse(dispatch, response);
                }
                break;
            // Response of User selected security questions update API
            case api_urls.UPDATE_SECURITY_QUESTIONS:
                {
                    updateSecrityQuestions_Status(dispatch, response);
                };
                break;
            case api_urls.UPDATE_STATUS_STAFF_PATIENT:
                { activateDeactivateStaff(dispatch, response); };
                break;
            case api_urls.GET_THERAPIST_LIST: { gettherpaistlist(dispatch, response) }
                break;
            case api_urls.GET_PSYCHIATRIST_LIST: { getpsychiatristlist(dispatch, response) }
                break;


            case api_urls.USER_TRIGGER_TIME: { triggerTime(dispatch, response) }
                break;
            case api_urls.FILLTER_PATIENT_BY_DR: { filterPatientdata(dispatch, response) }
                break;

            //Response of Patients upload csv
            case api_urls.UPLOAD_PATIENTS_REGISTRATION_CSV: {
                fileUploadRegistration(dispatch, response);
            };
                break;
            //Response of staff upload csv
            case api_urls.UPLOAD_STAFF_REGISTRATION_CSV: {
                fileUploadRegistration(dispatch, response);
            };
                break;
            //patient reports cases
            case api_urls.REPORT_SELF_CARE: {
                send_self_care_data(dispatch, response);
            };
                break;
            case api_urls.REPORT_MYTHOUGHTS: {
                send_mythoughts_data(dispatch, response);
            };
                break;
            case api_urls.REPORT_MYACTIVITY: {
                send_myactivity_data(dispatch, response);
            };
                break;
            case api_urls.REPORT_MYEXPERIENCE: {
                send_myaexperience_data(dispatch, response);
            };
                break;

            case api_urls.PATIENTS_SURVEY_RESPONSE: {
                patientsurveyFaild(dispatch, response);
            };
                break;
            case api_urls.CSV_REPORT_ADMIN: {
                sendCsvReportAdmin(dispatch, response);
            };
                break;
            case api_urls.CSV_REPORT_SUPER_ADMIN: {
                sendCsvReportSuperAdmin(dispatch, response);
            };
                break;
            case api_urls.ACTIVE_FACILITY: {
                sendActiveFacilty(dispatch, response);
            };
                break;
            case api_urls.ADDQUESTIONSTOSURVEY: {
                addquestionTosurveyFaild(dispatch, response);
            };
                break;
            case api_urls.ADMIN_UNIQUE_QUESTION_ALL: {
                adminUniqueQuestionAllFaild(dispatch, response);
            };
                break;
            case api_urls.USER_LOG_OUT: {
                logoutUserSession(dispatch, response);
            };
                break;

            case api_urls.USER_AUTO_LOG_OUT: {
                logoutUserSession(dispatch, response);
            };
                break;
                case api_urls.RESEND_EXPIRED_LINK: {
                    setResendLink(dispatch, response);
                };
                    break;
                    case api_urls.USER_REDFLAG_RESLOVE: {
                        resloveRedFlags(dispatch, response);
                    };

                    break;
                    case api_urls.GET_SECURE_REASON: {
                        resolvedReasons(dispatch, response);
                    };
                        break;
            default: {
                if (response) {
                    return response;
                } else {
                    return { status: 200, message: 'No data.' };
                }
            }
        }
    };

/*  ------------------Deals API Failed Handler---------------------------  */
function serverNotFound(dispatch, response) {
    //dispatch(UserActions.loginFaild(response));
    //alert('Server not found.')
}

function otpFailure(dispatch, response) {
    dispatch(UserActions.otpSuccess(response));    
}

function multi_facility_request(dispatch, response) {
    dispatch(UserActions.MultifacilityRequest_data(response));
}
function exportData(dispatch, response) {
    dispatch(TicketActions.exportDataResponse(response));

}

function loginFailedDetails(dispatch, response) {    
    dispatch(UserActions.loginFaild(response));
}
function userNameFailed(dispatch, response) {

    dispatch(UserActions.getUserNameFail(response));

}
function forgotPwdFailed(dispatch, response) {

    dispatch(UserActions.userPasswordDetail(response));

}
function getSurveList(dispatch, response) {
    dispatch(UserActions.survey_list_data(response));
}


function getSecurQuesiton(dispatch, response) {

    dispatch(SettingScreen.getSecurQuesitonFail(response));
}

function changepasswordFaild(dispatch, response) {

    dispatch(SettingScreen.ChangePassResponse(response));
}
function verifypasswordFaild(dispatch, response) {

    dispatch(SettingScreen.verifyPassFaild(response));
}

function Profile_Update(dispatch, response) {
    dispatch(SettingScreen.Profile_Update(response));
}

function dashboardfail(dispatch, response) {

    dispatch(DashboardActions.dashboardDetailsFail(response));

}
function notificationFail(dispatch, response) {

    dispatch(DashboardActions.nofificationDetailsFail(response));

}
function sendActiveFacilty(dispatch, response) {

    dispatch(DashboardActions.active_facilty_data(response));

}

function questionnaireFail(dispatch, response) {

    dispatch(QuestionnaireActions.questionnaireDetailsFail(response));

}

// need to remove, will be deprecated. now using "GET_FACILITIES_BY_SEARCH" api instead of this.
function getgetFaclity(dispatch, response) {

    dispatch(FacilitiesActions.FacilityDetails(response));
}


function answerFaild(dispatch, response) {

    dispatch(FacilitiesActions.answerFaildDetails(response));
}
function createUniqueFaild(dispatch, response) {

    dispatch(QuestionnaireActions.createUniqueFaildData(response));
}

function createFaclity(dispatch, response) {

    dispatch(FacilitiesActions.AddedFacility(response));
}
function updateFaclity(dispatch, response) {

    dispatch(FacilitiesActions.facilityUpdate(response));
}
function getFaclitybyId(dispatch, response) {
    dispatch(FacilitiesActions.FacilityDetailsByID(response));
}
function addFaclitybyAdmin(dispatch, response) {
    dispatch(FacilitiesActions.addFacilityAdmin(response));
}
function getFacilityAdmin(dispatch, response) {
    dispatch(FacilitiesActions.getAdminUser(response));
}

function quetionUpDate(dispatch, response) {
    dispatch(QuestionnaireActions.qusUpdateFail(response));
}
// get facilities by search failure response
function getfacilitiesbySearch(dispatch, response) {
    // binded the getfacilitybysearch api to facility details api
    dispatch(FacilitiesActions.FacilityDetails(response));
}

function activatefacilityadmin(dispatch, response) {
    dispatch(FacilitiesActions.activate_facilty_admin(response));
}
function deactivatefacilityadmin(dispatch, response) {
    dispatch(FacilitiesActions.dectivate_facilty_admin(response));
}
function verficationFaild(dispatch, response) {
    dispatch(SettingScreen.verficationFaildData(response));
}
// Verify answers of Security Questions fail
function securityQuestionFaild(dispatch, response) {
    dispatch(UserActions.verifyAnswersFaild(response));
}
function updateSQFaild(dispatch, response) {
    dispatch(UserActions.updateSQFaildData(response));
}
function uploadFacilityImage(dispatch, response) {
    dispatch(UserActions.upload_Facility_Image(response));
}

function deactivatefacility(dispatch, response) {
    dispatch(FacilitiesActions.deactive_facility(response));
}


// Registration
function getHighestDegrees(dispatch, response) {
    dispatch(UserActions.get_highestDegrees(response));
}
function getProfessionalRoles(dispatch, response) {
    dispatch(UserActions.get_professionalRoles(response));
}
function getEthnicities(dispatch, response) {
    dispatch(UserActions.get_ethnicities(response));
}


//Admin users
// deprecated need to remove
function get_patients_data(dispatch, response) {
    dispatch(PatientsActions.all_patients_data(response));
}
// deprecated need to remove
function get_staff_data(dispatch, response) {
    dispatch(PatientsActions.all_staff_data(response));
}

// USERS_BY_ROLE
function set_Users_By_Role(dispatch, response) {
    dispatch(UserActions.setUsersByRole(response));
}

function adminDashboard(dispatch, response) {
    dispatch(AdminDashboardActions.adminDashboard_data_failed(response));
}

function getPatientinfo(dispatch, response) {
    dispatch(PatientsActions.get_patient_info_data(response));
}
function getRedFlagInfo(dispatch, response) {
    dispatch(PatientsActions.red_flag_Data(response));
}

function adminSelectFail(dispatch, response) {
    dispatch(AdminSettingAactions.adminSelect_data_failed(response));
}

function adminDeactivateFail(dispatch, response) {
    dispatch(AdminSettingAactions.adminDeactivate_data_failed(response));
}

// Response of all security questions API
function setAllSecrityQuestionsResponse(dispatch, response) {
    dispatch(SettingScreen.SetAllSecurityQuestions(response));
}
//Response of random security questions by id
function setAllRandomSecurityQuestionsByIdResponse(dispatch, response) {
    dispatch(SettingScreen.setAllRandomSecurityQuestionsById(response));
}

// Response of User selected security questions update API
function updateSecrityQuestions_Status(dispatch, response) {
    dispatch(SettingScreen.setUpdateSecurityQuestionsStatus(response));
}

function activateDeactivateStaff(dispatch, response) {
    dispatch(SettingScreen.updateStaffSatusData(response));
}


function gettherpaistlist(dispatch, response) {
    dispatch(UserActions.therapist_list_Data(response));
}
function getpsychiatristlist(dispatch, response) {
    dispatch(UserActions.psychiatrist_list_Data(response));
}


function triggerTime(dispatch, response) {
    dispatch(UserActions.user_trigger_time(response));
}
function filterPatientdata(dispatch, response) {
    dispatch(UserActions.fillter_patient_data(response));
}

function fileUploadRegistration(dispatch, response) {
    dispatch(UserActions.setFileUploadRegistration(response));
}

function send_self_care_data(dispatch, response) {
    dispatch(ReportActions.selfe_care_data(response));

}
function send_mythoughts_data(dispatch, response) {
    dispatch(ReportActions.mythoughts_data(response));

}
function send_myactivity_data(dispatch, response) {
    dispatch(ReportActions.myActivity_data(response));

}
function send_myaexperience_data(dispatch, response) {
    dispatch(ReportActions.myExperienceData(response));
}
function patientsurveyFaild(dispatch, response) {
    dispatch(UserActions.patientsurveyFaildData(response));
}


function sendCsvReportAdmin(dispatch, response) {
    dispatch(ReportActions.csv_report_admin_data(response));
}
function sendCsvReportSuperAdmin(dispatch, response) {
    dispatch(ReportActions.csv_report_super_admin_data(response));
}
function addquestionTosurveyFaild(dispatch, response) {
    dispatch(UserActions.addquestionTosurveyFaild_data(response));
}
function adminUniqueQuestionAllFaild(dispatch, response) {
    dispatch(UserActions.adminUniqueQuestionAllFaild_data(response));
}
function logoutUserSession(dispatch, response) {
    dispatch(UserActions.setSessionLogout(response));
}
function setResendLink(dispatch,response) {
  dispatch(FacilitiesActions.ResendLink(response));
}

function resloveRedFlags(dispatch,response) {
    dispatch(UserActions.user_redflag_reslove(response));
  }
  

  function resolvedReasons(dispatch, response) {
    dispatch(ReasonActions.getReasons(response));
}


/** WEBPACK FOOTER **
 ** ./src/base/failed_manager.js
 **/